import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,
  Button,
  Grid,
} from "@material-ui/core";
import { UserContext } from "../../context/UserContext";
import MaskService from "../../utils/mask/maskService";
import { Card, CardHeader } from "reactstrap";

import api from "../../services/api";
import { notify } from "../../utils/notify";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import SearchInput from "../../components/basic/SearchInput";
import filterTable from "../../utils/filterTable";
import "./.promoter.css";

function createData(CNPJ, IE, IM, Fantasia, TipoPromotor, Razao, Status) {
  return {
    CNPJ,
    IE,
    IM,
    Fantasia,
    TipoPromotor,
    Razao,
    Status,
  };
}

const headCells = [
  {
    name: "CNPJ",
    numeric: false,
    disablePadding: false,
    label: "CNPJ/CPF",
    sort: true,
  },
  {
    name: "IE",
    numeric: false,
    disablePadding: false,
    label: "IE",
    sort: true,
  },
  {
    name: "IM",
    numeric: false,
    disablePadding: false,
    label: "IM",
    sort: true,
  },
  {
    name: "Fantasia",
    numeric: false,
    disablePadding: false,
    label: "Fantasia",
    sort: true,
  },

  {
    name: "TipoPromotor",
    numeric: false,
    disablePadding: false,
    label: "Tipo de promotor",
    sort: false,
  },
  {
    name: "Razao",
    numeric: false,
    disablePadding: false,
    label: "Razão",
    sort: false,
  },
  {
    name: "Status",
    numeric: false,
    disablePadding: false,
    label: "Status",
    sort: false,
  },
  {
    name: "Acoes",
    numeric: false,
    disablePadding: false,
    label: "Ações",
    sort: false,
  },
];

function EnhancedTableHead() {
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell key={headCell.name} padding={"default"}>
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  row: {
    margin: "1px",
  },
}));

const PreviewPromoter = () => {
  const { user } = useContext(UserContext);
  const [actionsPermission, setActionsPermission] = useState({
    delete: false,
    edit: false,
  });
  const history = useHistory();
  const classes = useStyles();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("CNPJ");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rowsFilter, setRowsFilter] = useState([]);

  const [rows, setRows] = useState([]);
  const [allRows, setAllRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.accessRoutes) {
      const actionPermission = {
        delete:
          user.accessRoutes.indexOf("/deletePromoter") === -1 ? false : true,
        edit:
          user.accessRoutes.indexOf("/updatePromoter") === -1 ? false : true,
      };

      setActionsPermission(actionPermission);
    }
  }, [user]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data: response } = await api.get("promotor/todos");

        const employees = response.data.map((employee) => {
          return createData(
            employee.CNPJ,
            employee.IE,
            employee.IM,
            employee.Fantasia,
            employee.TipoPromotor,
            employee.Razao,
            employee.Status
          );
        });
        setRows(employees);
        setRowsFilter(employees);
        setAllRows(response.data);
        setLoading(false);
      } catch (error) {
        console.error("ERROR: PreviewPromoter", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleRequestSort = (_, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.nome);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const handleNewInsert = () => {
    history.push("/createPromoter");
  };

  const handleEdit = (CNPJ) => {
    const rowEdit = allRows.find((rw) => rw.CNPJ === CNPJ);
    if (rowEdit) {
      history.push("/updatePromoter", { row: rowEdit });
    } else {
      notify("Registro não encontrado.");
    }
  };

  const handleDelete = async (CNPJ, Fantasia) => {
    if (window.confirm(`Você realmente quer apagar o promotor ${Fantasia}`)) {
      const rowDelete = allRows.find((rw) => rw.CNPJ === CNPJ);

      if (rowDelete) {
        try {
          setLoading(true);

          const { data: deletePromoter } = await api.delete(`promotor/${CNPJ}`);

          if (deletePromoter.success) {
            const removeItem = rows.filter((item) => item.CNPJ !== CNPJ);
            setRows(removeItem);
            setRowsFilter(removeItem);
            notify("Promotor deletado com sucesso.", true, "info");
          }
          setLoading(false);
        } catch (error) {
          console.error("ERROR: DeletePromoter", error);
          setLoading(false);
        }
      } else {
        notify("Registro não encontrado.");
      }
    }
  };

  const handleChangeFilter = (e) => {
    if (!e) return setRowsFilter(allRows);

    const newArr = filterTable({
      data: rows,
      text: e.target.value,
      columns: ["CNPJ", "Fantasia", "Razao", "TipoPromotor", "Status"],
    });

    setRowsFilter(newArr);
    setPage(0);
  };

  return (
    <>
      {loading && <ModalLoading loading={loading} />}

      <div className="containerTable">
        <Card className="card-default">
          <CardHeader className={classes.row}>
            <Grid container alignItems="center" spacing={1}>
              <Grid item lg={4} md={6} sm={12} xs={12}>
                <label className="title">Promotores</label>
              </Grid>

              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SearchInput
                  placeholder="Pesquisar"
                  handleChange={handleChangeFilter}
                />
              </Grid>

              <Grid
                container
                justify="flex-end"
                alignItems="center"
                item
                lg={2}
                md={12}
                sm={12}
                xs={12}
              >
                <Grid item>
                  <Button
                    variant="contained"
                    size="large"
                    id="buttonInserir"
                    onClick={handleNewInsert}
                  >
                    <img
                      src="img/inserir.svg"
                      className="iconInserir"
                      alt="Inserir"
                    />
                    INSERIR
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardHeader>
          <hr />
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size="medium"
              aria-label="enhanced table"
            >
              <EnhancedTableHead
                classes={classes}
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rowsFilter.length}
              />
              <TableBody>
                {rowsFilter
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow hover tabIndex={-1} key={index}>
                        <TableCell align="left">
                          {MaskService.toMask(
                            row.CNPJ.length === 14 ? "cnpj" : "cpf",
                            row.CNPJ
                          )}
                        </TableCell>
                        <TableCell align="left">{row.IE}</TableCell>
                        <TableCell align="left">{row.IM}</TableCell>
                        <TableCell align="left">{row.Fantasia}</TableCell>
                        <TableCell align="left">{row.TipoPromotor}</TableCell>

                        <TableCell align="left">{row.Razao}</TableCell>
                        <TableCell align="left">{row.Status}</TableCell>
                        <TableCell align="left">
                          {actionsPermission.edit && (
                            <Tooltip title="Editar">
                              <IconButton
                                aria-label="edit"
                                onClick={() => handleEdit(row.CNPJ)}
                              >
                                <img
                                  alt="Editar"
                                  src="img/acoes.svg"
                                  className="iconAtivo"
                                />
                              </IconButton>
                            </Tooltip>
                          )}
                          {actionsPermission.delete && (
                            <Tooltip title="Deletar">
                              <IconButton
                                aria-label="delete"
                                onClick={() =>
                                  handleDelete(row.CNPJ, row.Fantasia)
                                }
                              >
                                <img
                                  alt="Deletar"
                                  src="img/excluir.svg"
                                  className="iconAtivo"
                                />
                              </IconButton>
                            </Tooltip>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={9} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            labelRowsPerPage={"LInhas por página"}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Card>
      </div>
    </>
  );
};

export default PreviewPromoter;
